import React, { useRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faBiking, faReply, faWalking, faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import PopupTab from './PopupTab';
import { NavLink } from 'react-router-dom';
import { setCookie, getPrivileges } from './../../functions/Auth';
import Cookies from 'js-cookie';
import API_PATH from "../../constants/config.json";
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

//Start Css code ...
const useStyles = makeStyles((theme) => ({
  
  capitalize: {
        textTransform: 'capitalize'
      },
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    padding: '0px',
    '& > *': {
      margin: theme.spacing(1),
      width: '98%',
    },
  },
  rootBox: {
    flexGrow: 1,
  },
  paper: {
    width: '100%',
    boxShadow: 'none',
  },
  interMainContainer: {
    background: '#fff',
    borderRadius: '5px',
    padding: '0px',
    borderRadius: '5px',
    '@media only screen and (max-width: 3500px)': {
      width: '500px',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '895px',
      maxWidth: '900px',
    },
  },
  intersection: {
    position: 'fixed',
    background: '#fff',
    left: '-2px',
    zIndex: '33',
    borderRadius: '5px',
    bottom: '5px',
    border: '1px solid #24618E',
    width: '505px',
    height: '86.8vh',
    '@media only screen and (max-height: 820px)': {
      height: '83vh'
    },
  },
  formHead: {
    padding: '15px 15px 15px 15px',
    overflow: 'hidden',
    '& h3': {
      color: '#24618E',
      fontSize: '25px',
      marginTop: '0px',
      marginBottom: '-10px',
    },
    '& img': {
      width: '100%',
      height: '2px',
    },
    '& h2': {
      '@media only screen and (min-width: 3501px)': {
        fontSize: '25pt',
      },
    }
  },
  teamsUl: {
    paddingLeft: '5px !important',
    paddingTop: 0,
    width: '100%',
    float: 'left',
    margin: '0',
    '& li': {
      listStyle: 'none',
      float: 'left',
      textAlign: 'center',
      marginLeft: '50px'
    },
  },
  btnIcon: {
    color: '#24618E',
    marginRight: '5px',
    // cursor: 'pointer',
  },
  btnIcons: {
    color: '#24618E',
    marginRight: '5px',
    cursor: 'pointer',
  },
  fieldsetname: {
    width: 'auto',
    border: '1px solid rgba(0, 167, 93, 1)',
    margin: '10px',
    marginRight: '0px',
    padding: '10px',
    borderRadius: '5px',
    marginTop: '0',
  },
  simpleBtn: {
    marginTop: '0px',
    border: '1px solid #333',
    color: '#333',
    background: '#fff !important',
    fontSize: '12px',
    width: '110px',
  },
  floatLeftBtn: {
    float: 'left',
  },
  floatRightBtn: {
    float: 'right',
    border: '1px solid #333',
    color: '#333',
    '@media only screen and (max-width: 3500px)': {
      width: '180px',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '275px',
    },
  },
  floatCenterBtn: {
    clear: 'both',
    border: '1px solid #333',
    padding: '5px 25px',
    color: '#333',
    '@media only screen and (min-width: 3501px)': {
      width: '180px',
    },
  },
  tableHead: {
    fontWeight: 'bolder',
    fontSize: '18px',
    textAlign: 'center',
    padding: 0
  },
  titleTD: {
    textAlign: 'left',
    fontSize: '18px',
    padding: 0
  },
  dataTD: {
    textAlign: 'center',
    fontSize: '18px',
    padding: 0
  },
  mainbtnDiv: {
    border: '1px solid #24618E',
    borderTop: 'none',
    borderRadius: '0px 0px 5px 5px',
    minHeight: '365px',
    '& .focusBtn': {
      color: "#fff",
      background: '#24618E',
    }
  },
  topIntPanelBtn: {
    width: '67%',
    float: 'right',
    marginBottom: '10px',
    '& button': {
      background: '#fff',
      '&:hover': {
        boxShadow: '4px 3px 3px 0px #999',
        background: '#fff',
      }
    }
  },
  intersectionDrop: {
    padding: '5px',
    width: '100%',
    '@media only screen and (max-width: 3500px)': {
      fontSize: '14pt',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '24pt',
    },
  },
  peakYourSome: {
    float: 'left',
    padding: '10px',
    border: '1px solid #00A75D',
    margin: '10px',
    marginTop: '15px',
    borderRadius: ' 5px',
    '@media only screen and (max-width: 3500px)': {
      width: '98%',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '98.9%',
    },
    '& legend': {
      marginLeft: '5px',
      color: '#000',
      position: 'relative',
      top: '-25px',
      background: '#fff',
      marginBottom: '-20px',
      '@media only screen and (max-width: 3500px)': {
        width: '176px',
      },
      '@media only screen and (min-width: 3501px)': {
        width: '310px',
      },
    }
  },
  intersectionBlocksMain: {
    width: '98.5%',
  },
  closePara: {
    '& :hover': {
      color: '#CC0000',
      cursor: 'pointer',
    }
  },
  closeIcon: {
    textAlign: 'right',
    margin: '0',
    position: 'absolute',
    top: '10px',
    cursor: 'pointer',
    color: '#24618E',
    '@media only screen and (max-width: 3500px)': {
      fontSize: '20pt',
      right: '10px',
      width: '40px',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '30pt',
      right: '15px',
      width: '60px',
    },
    '&:hover': {
      color: '#CC0000',
    }
  }
}));
//End Css code ...

let hourAmData = [];
let hourPmData = [];
let hourMidData = [];
let minAmData = [];
let minPmData = [];
let minMidData = [];

let fullTimeData = { 'hourAmData': hourAmData, 'hourPmData': hourPmData, 'hourMidData': hourMidData, 'minAmData': minAmData, 'minPmData': minPmData, 'minMidData': minMidData };

//Start Intersection component code ...
const Intersection = props => {

  useEffect(
    () => {
      getStationRecentYear();
      getIntersectionDatePeakData();
    }, [props.searchPanel, props.stationData]);

  const [spacing, setSpacing] = React.useState(2);
  const classes = useStyles();
  const myRef = useRef(null);
  const [value, setValue] = React.useState(2);

  const [turningCountDate, setTurningCountDate] = React.useState();
  const [pedestrianCountDate, setPedestrianCountDate] = React.useState();
  const [biCycleCountDate, setBiCycleCountDate] = React.useState();
  const [peakDate, setPeakDate] = React.useState();
  const [selectedDate, setSelectedDate] = React.useState([]);
  const [dateVal, setDateVal] = React.useState([]);
  const [AMdata, setAMdata] = React.useState(null);
  const [MIDdata, setMIDdata] = React.useState(null);
  const [PMdata, setPMdata] = React.useState(null);
  const [peakData, setPeakData] = React.useState();
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]

  const days = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ]

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  let stationData = props.stationData;

  //This function is used for export data
  const goToIntersectionDetails = () => {
    setCookie("latitude", props.stationData.latitude);
    setCookie("longitude", props.stationData.longitude);
    window.open('/intersection_details?station=' + props.stationData.client_station_id, '_blank');
  }

  //This method is use for API call to get recent year of station Data .... Start
  const getStationRecentYear = () => {
    try {
      axios({
        method: 'post',
        url: API_URL + API_PATH.getStationRecentYear,
        data: {
          stationId: stationData.station_id
        }
      }).then(function (response) {
        if (response && response.data.data) {
          setTurningCountDate(response.data.data.turningyear);
          setPedestrianCountDate(response.data.data.pedestrianyear);
          setBiCycleCountDate(response.data.data.bicycleyear);
        } else {
        }
      })
    }
    catch (error) {
    }
  }
  //This method is use for API call to get recent year of station Data .... End

  //This function is used for export data ... start
  const setExportData = () => {
    props.groupStations(stationData.station_id, stationData.station_type, stationData.client_station_id, stationData.station_location);
    props.checkExportValue();
  }
  //This function is used for export data .. End

  //This method is use for API call to get date of intersection .... Start
  const getIntersectionDatePeakData = () => {
    try {
      axios({
        method: 'post',
        url: API_URL + API_PATH.getIntersectionDatePeakData,
        data: {
          stationId: props.stationData.station_id
        }
      }).then(function (response) {
        if (response && response.data.data) {
          let data = response.data.data;
          setPeakData(data);
          let tempPeakArr = [];
          let tempPeakValArr = [];
          data.map((val) => {
            tempPeakValArr.push(val.date);
            let date = new Date(val.date);
            const monthIndex = date.getMonth();
            const monthName = months[monthIndex];
            const dayIndex = date.getDay();
            const dayName = days[dayIndex];
            tempPeakArr.push(val.date);
          });
          setSelectedDate(tempPeakValArr[0]);
          setDateVal(tempPeakValArr);
          setPeakDate(tempPeakArr);
          if (data && data[0] && data[0].am) {
            setAMdata(data[0].am);
          }
          if (data && data[0] && data[0].mid) {
            setMIDdata(data[0].mid);
          }
          if (data && data[0] && data[0].pm) {
            setPMdata(data[0].pm);
          }
        }
        else {
          setSelectedDate([]);
          setDateVal([]);
          setPeakDate([]);
          setAMdata([]);
          setMIDdata([]);
          setPMdata([]);
        }
      })
    }
    catch (error) {
    }
  }
  //This method is use for API call to get date of intersection .... End

  //This method is use for to change date of intersection .... Start
  const onDateChange = (e) => {
    peakData && peakData.length > 0 && peakData.map((val) => {
      if (val.date == e.target.value) {
        if (val.am) {
          setAMdata(val.am);
        }
        if (val.mid) {
          setMIDdata(val.mid);
        }
        if (val.pm) {
          setPMdata(val.pm);
        }
      }
    })
  }
  //This method is use for to change date intersection .... End

  return (
    <React.Fragment>
      <CssBaseline />
      <div className={classes.intersection} ref={myRef} style={props.showExternalLayers ? {left: props.sidebarWidth} : {left: '-2px'}}>
        <Container maxWidth="sm" className={['intersectionContainer', classes.container, classes.interMainContainer]}>
          <div className={classes.formHead}>
            {props.searchChecked ? <p style={{ marginBottom: '10px', marginTop: '0' }}><NavLink to="#" style={{ color: '#24618E' }} onClick={() => props.passIntersectionValue()} ><FontAwesomeIcon icon={faAngleLeft} />&nbsp;Back to Search Results</NavLink></p> : null}
            <span> Intersection Station ID: {props.stationData && props.stationData.client_station_id ? props.stationData.client_station_id : <span> N/A </span>} </span>
            <h2 style={{ margin: 0, marginBottom: '-12px', padding: 0 }}> {props.stationData && props.stationData.station_location ? props.stationData.station_location : <span> N/A </span>} </h2>
            <p className={classes.closeIcon} onClick={props.passIntersectionValue} title='Close'>
              <FontAwesomeIcon icon={faTimes} className={classes.btnIcons} title='Close' />
            </p>
            <img src={require('../../assets/images/hrimg.svg')} />
            <Grid xs={12} item style={{ marginTop: "10px" }}>
              <Paper className={classes.paper} style={{ textAlign: 'center' }} >
                <div className={classes.topIntPanelBtn}>
                  {
                    getPrivileges().length !== 0 ?
                      <> <Button variant="outlined" id="export_btn" data-testid="export_btn" onClick={() => setExportData()} className={classes.simpleBtn, classes.floatCenterBtn} disabled={turningCountDate || pedestrianCountDate || biCycleCountDate ? false : true}>
                        Export
                  </Button>
                        <Button variant="outlined" id="view_all_details_btn" data-testid="view_all_details_btn"
                          className={classes.simpleBtn, classes.floatRightBtn}
                          onClick={goToIntersectionDetails}>
                          View All Details
                 </Button>
                      </>
                      :
                      null
                  }
                </div>
              </Paper>
            </Grid>
          </div>

          <div className={props.searchChecked ? 'withSearch' : 'withoutSearch'}>
            <Typography component="div" className={getPrivileges().length === 0 ? 'stationBlocktypoBlank' : 'stationBlocktypo'}>
              <div className={classes.intersectionBlocksMain}>
                <fieldset className={classes.fieldsetname} style={{ paddingTop: 0 }}>
                  <legend>Most Recent Data Types</legend>
                  <Grid container className={classes.rootBox} spacing={spacing}>
                    <Grid item xs={12}>
                      <Grid container justify="center" spacing={spacing}>
                        <Grid xs={12} item>
                          <Paper className={classes.paper} >
                            {
                              (turningCountDate || pedestrianCountDate || biCycleCountDate) ?
                                <ul className={classes.teamsUl}>
                                  {
                                    turningCountDate ?
                                      <li style={{ marginLeft: '0px', marginRight: '50px' }} title='Turning Movement'>
                                        <FontAwesomeIcon icon={faReply} className={classes.btnIcon} /> <br />
                                        {turningCountDate}
                                      </li> : null
                                  }
                                  {
                                    pedestrianCountDate ?
                                      <li style={{ marginLeft: '0px', marginRight: '50px' }} title='Pedestrian'>
                                        <FontAwesomeIcon icon={faWalking} className={classes.btnIcon} /> <br />
                                        {pedestrianCountDate}
                                      </li> : null
                                  }
                                  {
                                    biCycleCountDate ?
                                      <li style={{ marginLeft: '0px' }} title='Bicycle'>
                                        <FontAwesomeIcon icon={faBiking} className={classes.btnIcon} /> <br />
                                        {biCycleCountDate}
                                      </li> : null
                                  }
                                </ul> : <p style={{ textAlign: 'center' }}> No data has been imported for this station </p>
                            }
                          </Paper>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </fieldset>
                <div className={classes.peakYourSome}>
                  <legend> Peak Hour Summary </legend>
                  {peakDate && peakDate.length > 0 ?
                    <>  <select id="date" className={classes.intersectionDrop}
                      onChange={(e) => onDateChange(e)} >
                      {peakDate.map((val, index) => {
                        return <option value={dateVal[index]}>{val}</option>
                      })
                      }
                    </select>
                      <PopupTab AMdata={AMdata} MIDdata={MIDdata} PMdata={PMdata} stationId={props.stationData.station_id} /></>

                    : <p style={{ textAlign: 'center' }}> No peak hour calculations are available for this station </p>
                  }
                </div>
                <fieldset className={classes.fieldsetname}>
                  <legend>Details</legend>
                  <Grid container className={classes.rootBox} spacing={spacing}>
                    <Grid item xs={12}>
                      <Grid container justify="center" spacing={spacing}>
                        <Grid xs={12} item>
                          <Paper className={classes.paper} >
                            <span style={{ textTransform: 'capitalize' }}> Status: {stationData && stationData.status ? stationData.status : <span> N/A </span>} </span> <br />
                            <span> Jurisdiction: {stationData && stationData.Jurisdiction_name ? stationData.Jurisdiction_name : <span> N/A </span>} </span> <br />
                            <span> County: {stationData && stationData.fips_county_code ? stationData.fips_county_code : <span> N/A </span>}</span> <br />
                            <span> Community: {stationData && stationData.community ? stationData.community : <span> N/A </span>} </span> <br />
                            <span> Lat / Long: {stationData && stationData.latitude ? parseFloat(stationData.latitude).toFixed(5) : null}, {stationData && stationData.longitude ? parseFloat(stationData.longitude).toFixed(5) : null} </span> <br />
                            <span> Description: {stationData && stationData.description ? stationData.description : <span> N/A </span>} </span> <br />
                          </Paper>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </fieldset>
              </div>
            </Typography>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Intersection;
//End Intersection component code ...
